import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TenantTable from "./TenantTable";
import { getTenants } from "../../store/AsyncMethods/TenantMethod";

export default function ManageTenantMain() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.AuthReducer);

  
  useEffect(() => {
    if (user) {
      dispatch(getTenants());
    }
  }, [user]);

  return (
    <div className="mx-3">
      <div className="flex justify-end">
        <Button
          label="Add Tenant"
          icon="pi pi-plus"
          className="p-primary-btn"
          onClick={() => {
            dispatch({ type: 'RESET_SPECIFIC_TENANTS' });
            navigate("/add-tenant");
          }}
        />
      </div>

      <div className="my-4">
        <TenantTable />
      </div>
    </div>
  );
} 